import { render, staticRenderFns } from "./KnownActionsListPage.vue?vue&type=template&id=e216ed76&"
import script from "./KnownActionsListPage.vue?vue&type=script&lang=js&"
export * from "./KnownActionsListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports